import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import RadarChartTemplate from "views/molecules/charts/template/RadarChartTemplate"

const SCOPES = ["indicative", "partielle", "totale"]

const ChartSDG13RgesnRadarMolecule = ({ websiteScore }) => {
  const { t } = useTranslation()

  const spider = websiteScore?.spider_ecodesign_categories

  if (!spider || !spider.label_keys.length) return null

  const labels = spider.label_keys.map((key) =>
    t(`analyze:websites.ecodesign_compliance_level.labels.${key}`)
  )

  const datasets = SCOPES.map((scope) => ({
    label: t(`analyze:websites.ecodesign_compliance_level.scopes.${scope}`),
    data: [...spider[scope]],
    unit: "%",
  }))

  return (
    <RadarChartTemplate
      title={t("analyze:websites.ecodesign_compliance_level.title")}
      datasets={datasets}
      labelKeys={labels}
      chartFill
      gapSize={20}
      helpText={t("analyze:websites.ecodesign_compliance_level.help")}
    />
  )
}

ChartSDG13RgesnRadarMolecule.propTypes = {
  websiteScore: PropTypes.shape({
    spider_ecodesign_categories: PropTypes.shape({
      label_keys: PropTypes.arrayOf(PropTypes.string).isRequired,
      totale: PropTypes.arrayOf(PropTypes.number).isRequired,
      partielle: PropTypes.arrayOf(PropTypes.number).isRequired,
      indicative: PropTypes.arrayOf(PropTypes.number).isRequired,
    }).isRequired,
  }).isRequired,
}

export default ChartSDG13RgesnRadarMolecule
